import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import React from 'react';

const ApplicationTableHeader = () => {
   const columns = [
      { key: 'applicationNumber', label: 'Application Number', width: '20%', align: 'left' },
      { key: 'applicationType', label: 'Application Type', width: '20%', align: 'center' },
      { key: 'requestType', label: 'Request Type', width: '15%', align: 'center' },
      { key: 'date', label: 'Date', width: '15%', align: 'center' },
      { key: 'status', label: 'Status', width: '15%', align: 'center' },
      { key: 'actions', label: 'Actions', width: '15%', align: 'center', className: 'table-actions' },
   ];

   return (
      <TableHeader>
         <TableRow>
            {columns.map((column) => (
               <TableHead
                  key={column.key}
                  className={`w-[${column.width}] ${column.align === 'center' ? 'text-center' : ''} ${column.className || ''}`}
               >
                  {column.label}
               </TableHead>
            ))}
         </TableRow>
      </TableHeader>
   );
};

export default ApplicationTableHeader;